import React from 'react'
import PropTypes from 'prop-types'

import DashboardSectionShell from './DashboardSectionShell'
import { resolveAvatarUrl } from '../connect_sections/connectMemberHelpers'

function getConnectUser(connect, currentUserId) {
  return currentUserId === connect.requestor_id ? connect.requestee : connect.requestor
}

function DashboardConnectsSection({ connectedUsers, currentUserId, missingImg }) {
  if (!connectedUsers || connectedUsers.length === 0) {
    return null
  }

  return (
    <DashboardSectionShell
      icon="users-alt"
      iconSolid={false}
      title={`${connectedUsers.length} Connect${connectedUsers.length === 1 ? '' : 's'}`}
      subtitle="Your language exchange circle"
    >
      <div className="dashboardConnectsRow">
        {connectedUsers.map((connect) => {
          const user = getConnectUser(connect, currentUserId)
          const firstName = (user.preferred_name || '').split(' ')[0]

          return (
            <button
              key={connect.id}
              type="button"
              className="dashboardConnectCircle"
              onClick={() => window.location.assign(`/profile/${user.slug}`)}
              aria-label={`View ${user.preferred_name}'s profile`}
            >
              <span className="dashboardConnectCircle__avatarWrap">
                <img
                  className="dashboardConnectCircle__avatar"
                  src={resolveAvatarUrl(user.avatar_url, missingImg)}
                  alt=""
                />
              </span>
              <span className="dashboardConnectCircle__name">{firstName}</span>
            </button>
          )
        })}
      </div>
      <div className="dashboardHomeSection__footer">
        <button
          type="button"
          className="small_button_secondary"
          onClick={() => window.location.assign('/connects')}
        >
          View all Connects
        </button>
      </div>
    </DashboardSectionShell>
  )
}

DashboardConnectsSection.propTypes = {
  connectedUsers: PropTypes.array.isRequired,
  currentUserId: PropTypes.number.isRequired,
  missingImg: PropTypes.string.isRequired,
}

export default DashboardConnectsSection
